import { IPasswordPolicy } from './IPasswordPolicy';

export class MaximumPasswordLengthPolicy implements IPasswordPolicy {

    private maxLength: number;

    public constructor(maxLength: number) {
        this.maxLength = maxLength;
    }

    public isValid(password: string): boolean {
        return password && password.length <= this.maxLength;
    }
}
